export const style = {
  cardStyle: {
    marginTop: '32px',
    position: 'relative',
  },
  cardDisabled: {
    backgroundColor: '#F3F4F6',
    pointerEvents: 'none',
  },
  listViewMode: {
    paddingBottom: 0,
  },
  Box: {
    sx: {
      bgcolor: 'transparent',
      color: 'primary.main',
      display: 'flex',
      alignItems: 'center',
    },
  },
  BoxLinkedin: {
    display: 'block',
    fontSize: 14,
    pointerEvents: 'all',
  },
  icon: {
    color: '#9CA3AF',
  },
} as const;
